
import styles from "../styles/style.module.scss";
import searchImg from "../../../images/search.svg"
const Filters = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
      className={styles.dropdowns}
    >
      <input type="datetime-local" />
      <div style={{ position: "relative" }}>
        <img
          src={searchImg}
          alt="search-icon"
          className={styles.searchIcon}
        />
        <input
          type="text"
          className={styles.autosuggestionInput}
          placeholder="Search"
        />
      </div>
    </div>
  );
};

export default Filters;
